<template>
  <div>
    <Breadcrumbs title="Dashboard" :breadcrumbs="[]" />

    <!-- MANAGEMENT DASHBOARD -->
    <div
      v-if="dashboardType === 'MANAGEMENT'"
      class="container-fluid dashboard-shell"
    >
      <div class="dashboard-pair-row">
        <div class="dashboard-card-slot">
          <TargetVsAchievement />
        </div>

        <div class="dashboard-card-slot">
          <LorryWiseSale />
        </div>
      </div>

      <div class="dashboard-pair-row">
        <div class="dashboard-card-slot">
          <SkuWiseSale />
        </div>

        <div class="dashboard-card-slot">
          <InvoiceAndPayment />
        </div>
      </div>

      <div class="dashboard-pair-row">
        <div class="dashboard-card-slot">
          <ProductiveLogs />
        </div>

        <div class="dashboard-card-slot dashboard-map-slot">
          <DistributionOfDealers />
        </div>
      </div>
    </div>

    <!-- AUTH DASHBOARD -->
    <div v-if="dashboardType === 'AUTH'" class="container-fluid"></div>

    <!-- DISTRIBUTOR DASHBOARD -->
    <div
      v-if="dashboardType === 'DISTRIBUTOR'"
      class="container-fluid dashboard-shell"
    >
      <div class="dashboard-pair-row">
        <div class="dashboard-card-slot">
          <TargetVsAchievement />
        </div>

        <div class="dashboard-card-slot">
          <LorryWiseSale />
        </div>
      </div>

      <div class="dashboard-pair-row">
        <div class="dashboard-card-slot">
          <SkuWiseSale />
        </div>

        <div class="dashboard-card-slot">
          <PaymentsCard />
        </div>
      </div>

      <div class="dashboard-pair-row">
        <div class="dashboard-card-slot">
          <ProductiveLogs />
        </div>

        <div class="dashboard-card-slot dashboard-map-slot">
          <DistributionOfDealers />
        </div>
      </div>
    </div>

    <!-- PLANT DASHBOARD -->
    <div v-if="dashboardType === 'PLANT'" class="container-fluid"></div>

    <!-- UNKNOWN DASHBOARD -->
    <div v-if="dashboardType === 'UNKNOWN'" class="container-fluid"></div>
    <div v-if="dashboardType === 'PLANT'" class="container-fluid"></div>

    <!-- Floating Real Time Tracker Button -->
    <button
      v-if="dashboardType === 'MANAGEMENT' || dashboardType === 'DISTRIBUTOR'"
      class="floating-live-track-btn"
      @click="navigateToRealTimeMap"
      :disabled="loading"
      title="Real Time Tracker"
    >
      <div v-if="loading" class="loading-spinner"></div>

      <i v-else class="fas fa-map-marker-alt"></i>
    </button>
  </div>
</template>

<script>
//Dashboard Components
import DistributionOfDealers from "@/pages/dashboard/common/cards/distribution_of_dealers.vue";
import DashboardCounts from "@/pages/dashboard/management/cards/dashboard_counts.vue";
import TargetVsAchievement from "@/pages/dashboard/management/cards/target_vs_achievement.vue";
import PurchaseOrderSummary from "@/pages/dashboard/management/cards/order_requests.vue";
import DistributorStock from "@/pages/dashboard/management/cards/distributor_stock.vue";
import InvoiceAndPayment from "@/pages/dashboard/management/cards/invoice_payments.vue";
import DealerVisitSummary from "@/pages/dashboard/management/cards/dealer_visits.vue";
import ComplaintSummary from "@/pages/dashboard/management/cards/complaints.vue";
import PaymentsCard from "@/pages/dashboard/distributor/cards/invoice_payment_card.vue";
import SKUWiseTargetVsAchievement from "@/pages/dashboard/distributor/cards/sku_wise_target_vs_achivement_card.vue";
import ComplaintsCard from "@/pages/dashboard/distributor/cards/complaint_card.vue";
import RecentSalesCard from "@/pages/dashboard/distributor/cards/dsr_wise_sale_card.vue";
import ProductiveLogs from "@/pages/dashboard/management/cards/productive_vs_non_productive_logs.vue";
import LorryWiseSale from "@/pages/dashboard/management/cards/lorry_wise_sale.vue";
import SkuWiseSale from "@/pages/dashboard/management/cards/sku_wise_sale.vue";

//API Services
import { getReportingUsersList } from "@/services/dataService";

//Dependencies
import { useToast } from "vue-toastification";

export default {
  components: {
    DistributionOfDealers,
    DashboardCounts,
    TargetVsAchievement,
    PurchaseOrderSummary,
    DistributorStock,
    InvoiceAndPayment,
    DealerVisitSummary,
    ComplaintSummary,
    PaymentsCard,
    SKUWiseTargetVsAchievement,
    ComplaintsCard,
    RecentSalesCard,
    ProductiveLogs,
    LorryWiseSale,
    SkuWiseSale,
  },
  data() {
    return {
      userRole: localStorage.getItem("user_label"),
      token: localStorage.getItem("token_set"),
      profileId: localStorage.getItem("profile_id"),
      dashboardType: null,
      loading: false,
    };
  },
  mounted() {
    this.getDashboardType(this.userRole);
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  methods: {
    // Get dashboard type based on user-role
    getDashboardType(userRole) {
      const managementRoles = [
        "CHAIRMAN",
        "GMD",
        "CLUSTER CEO",
        "CEO",
        "NSM",
        "FSM",
        "ASM",
        "BACK OFFICE",
      ];
      const adminRoles = ["AUTH"];
      const distributorRoles = ["DISTRIBUTOR", "DISTRIBUTOR BACK OFFICE"];
      const plantRoles = ["PLANT"];

      if (managementRoles.includes(userRole)) {
        this.dashboardType = "MANAGEMENT";
      } else if (adminRoles.includes(userRole)) {
        this.dashboardType = "AUTH";
      } else if (distributorRoles.includes(userRole)) {
        this.dashboardType = "DISTRIBUTOR";
      } else if (plantRoles.includes(userRole)) {
        this.dashboardType = "PLANT";
      } else {
        this.dashboardType = "UNKNOWN";
      }
    },

    // Store reporting user's userIds
    // Navigate to the real-time gps tracker screen
    async navigateToRealTimeMap() {
      try {
        this.loading = true;
        const response = await getReportingUsersList(
          this.token,
          this.profileId,
        );
        console.log(response);

        if (response.data && response.data.status === "success") {
          // ✅ FIX: Use JSON.stringify to properly store the array of objects
          localStorage.setItem("UserIds", JSON.stringify(response.data.data));

          // Navigate to the real-time gps tracker screen
          this.$router.push("/real-time-tracker");
        } else {
          this.toast.error(response.data.message);
        }
      } catch (e) {
        this.toast.error("Something went wrong!");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.dashboard-shell {
  padding: 6px 8px 14px;
  max-width: 100%;
  overflow-x: hidden;
}

/* Pair rows keep equal height on desktop */
.dashboard-pair-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  align-items: stretch;
  margin-bottom: 8px;
}

.dashboard-card-slot {
  min-width: 0;
  width: 100%;
  display: flex;
}

/* Force child wrappers to fill available width/height */
.dashboard-card-slot :deep(.col-sm-12),
.dashboard-card-slot :deep(.col-xl-12),
.dashboard-card-slot :deep(.col-lg-12),
.dashboard-card-slot :deep(.col-md-12),
.dashboard-card-slot :deep(.container-fluid),
.dashboard-card-slot :deep(.row) {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  height: 100%;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* Premium dashboard card base */
.dashboard-card-slot :deep(.card) {
  width: 100%;
  height: 100%;
  min-width: 0;
  border: 1px solid #edf1f6;
  border-radius: 15px;
  background: #ffffff;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.045);
  overflow: hidden;
  margin-bottom: 0 !important;
  display: flex;
  flex-direction: column;
}

/* Compact card header */
.dashboard-card-slot :deep(.card-header) {
  padding: 9px 11px 7px !important;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(180deg, #ffffff 0%, #fbfcff 100%);
  flex-shrink: 0;
}

/* Compact body */
.dashboard-card-slot :deep(.card-body) {
  padding: 7px 9px 9px !important;
  flex: 1;
  min-height: 0;
}

/* Card titles */
.dashboard-card-slot :deep(.card-header h5),
.dashboard-card-slot :deep(h5) {
  margin: 0;
  font-size: 13px !important;
  font-weight: 750 !important;
  line-height: 1.25;
  color: #111827;
  text-transform: none !important;
  letter-spacing: -0.01em;
}

/* Header rows should wrap instead of overlap */
.dashboard-card-slot :deep(.header-top),
.dashboard-card-slot :deep(.card-header > div),
.dashboard-card-slot :deep(.d-flex) {
  min-width: 0;
  flex-wrap: wrap;
}

/* Compact inputs/buttons */
.dashboard-card-slot :deep(select),
.dashboard-card-slot :deep(.form-select),
.dashboard-card-slot :deep(input),
.dashboard-card-slot :deep(.btn) {
  min-height: 30px;
  font-size: 11.5px !important;
  border-radius: 8px;
}

.dashboard-card-slot :deep(.form-select) {
  padding: 4px 26px 4px 9px !important;
  border-color: #e1e7ef;
  color: #1f2937;
  font-weight: 550;
  box-shadow: none;
}

.dashboard-card-slot :deep(.form-select:focus) {
  border-color: #7064f5;
  box-shadow: 0 0 0 3px rgba(112, 100, 245, 0.1);
}

.dashboard-card-slot :deep(.btn) {
  padding: 5px 9px !important;
  font-weight: 650;
}

/* Compact typography */
.dashboard-card-slot :deep(h3) {
  font-size: 16px !important;
}

.dashboard-card-slot :deep(h4) {
  font-size: 14.5px !important;
}

.dashboard-card-slot :deep(h6) {
  font-size: 11.5px !important;
}

.dashboard-card-slot :deep(p),
.dashboard-card-slot :deep(span),
.dashboard-card-slot :deep(label) {
  font-size: 11.5px;
}

/* Prevent long text overflow */
.dashboard-card-slot :deep(p),
.dashboard-card-slot :deep(span),
.dashboard-card-slot :deep(h3),
.dashboard-card-slot :deep(h4),
.dashboard-card-slot :deep(h5),
.dashboard-card-slot :deep(h6) {
  overflow-wrap: anywhere;
}

/* Charts */
.dashboard-card-slot :deep(.chart-container),
.dashboard-card-slot :deep(.chart-right),
.dashboard-card-slot :deep(.overview-wrapper),
.dashboard-card-slot :deep(.current-sale-container),
.dashboard-card-slot :deep(.order-container) {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden !important;
}

.dashboard-card-slot :deep(.apexcharts-canvas),
.dashboard-card-slot :deep(.apexcharts-svg),
.dashboard-card-slot :deep(.apexcharts-inner),
.dashboard-card-slot :deep(foreignObject) {
  max-width: 100% !important;
}

/* Tables */
.dashboard-card-slot :deep(.table-responsive),
.dashboard-card-slot :deep(.appointment-table),
.dashboard-card-slot :deep(.recent-table),
.dashboard-card-slot :deep(.customer-table),
.dashboard-card-slot :deep(.transaction-table) {
  width: 100%;
  max-width: 100%;
  overflow-x: auto !important;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.dashboard-card-slot :deep(.table-responsive::-webkit-scrollbar),
.dashboard-card-slot :deep(.appointment-table::-webkit-scrollbar),
.dashboard-card-slot :deep(.recent-table::-webkit-scrollbar),
.dashboard-card-slot :deep(.customer-table::-webkit-scrollbar),
.dashboard-card-slot :deep(.transaction-table::-webkit-scrollbar) {
  height: 4px;
  width: 4px;
}

.dashboard-card-slot :deep(.table-responsive::-webkit-scrollbar-track),
.dashboard-card-slot :deep(.appointment-table::-webkit-scrollbar-track),
.dashboard-card-slot :deep(.recent-table::-webkit-scrollbar-track),
.dashboard-card-slot :deep(.customer-table::-webkit-scrollbar-track),
.dashboard-card-slot :deep(.transaction-table::-webkit-scrollbar-track) {
  background: transparent;
}

.dashboard-card-slot :deep(.table-responsive::-webkit-scrollbar-thumb),
.dashboard-card-slot :deep(.appointment-table::-webkit-scrollbar-thumb),
.dashboard-card-slot :deep(.recent-table::-webkit-scrollbar-thumb),
.dashboard-card-slot :deep(.customer-table::-webkit-scrollbar-thumb),
.dashboard-card-slot :deep(.transaction-table::-webkit-scrollbar-thumb) {
  background: #cbd5e1;
  border-radius: 999px;
}

.dashboard-card-slot :deep(table) {
  width: 100%;
  font-size: 11.5px;
  margin-bottom: 0;
}

.dashboard-card-slot :deep(th),
.dashboard-card-slot :deep(td) {
  font-size: 11.5px !important;
  line-height: 1.35;
  padding: 6px 7px !important;
  vertical-align: middle;
  white-space: nowrap;
}

.dashboard-card-slot :deep(th) {
  font-weight: 700;
  color: #475569;
}

/* Target card responsive fix */
.dashboard-card-slot :deep(.target-card) {
  height: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.dashboard-card-slot :deep(.target-card-header) {
  flex-shrink: 0;
}

.dashboard-card-slot :deep(.target-card-body) {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* Target filters must wrap naturally */
.dashboard-card-slot :deep(.target-filter-bar) {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-width: 0;
}

.dashboard-card-slot :deep(.target-filter-select) {
  flex: 1 1 108px;
  min-width: 0;
  max-width: 180px;
  height: 30px;
  min-height: 30px;
  font-size: 11.5px !important;
}

.dashboard-card-slot :deep(.target-user-select) {
  flex: 1 1 150px;
  max-width: 230px;
}

.dashboard-card-slot :deep(.target-year-select) {
  flex: 0 0 82px;
  max-width: 90px;
}

.dashboard-card-slot :deep(.target-sku-select) {
  flex: 1 1 118px;
  max-width: 190px;
}

.dashboard-card-slot :deep(.target-measure-select) {
  flex: 1 1 112px;
  max-width: 165px;
}

.dashboard-card-slot :deep(.target-view-btn) {
  flex: 0 0 auto;
  height: 30px;
  min-height: 30px;
  font-size: 11.5px !important;
}

/* Target chart should resize when filters wrap */
.dashboard-card-slot :deep(.target-card .chart-container) {
  flex: 1;
  min-width: 0;
  width: 100%;
  min-height: 245px;
  overflow-x: hidden !important;
}

/* Invoice payments card equal height */
.dashboard-card-slot :deep(.appointment) {
  width: 100%;
  height: 100%;
  min-width: 0;
  display: flex;
}

.dashboard-card-slot :deep(.invoice-payments-card) {
  height: 100%;
}

/* Invoice summary cards safety */
.dashboard-card-slot :deep(.invoice-summary-grid) {
  width: 100%;
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.dashboard-card-slot :deep(.invoice-summary-card) {
  min-width: 0;
}

/* Small summary/metric cards */
.dashboard-card-slot :deep(.small-widget),
.dashboard-card-slot :deep(.summary-card),
.dashboard-card-slot :deep(.light-card),
.dashboard-card-slot :deep(.balance-card),
.dashboard-card-slot :deep(.count-card) {
  min-width: 0;
  border-radius: 12px !important;
  padding: 8px 9px !important;
}

/* Map card should use the full available card box */
.dashboard-map-slot :deep(.card) {
  height: 100%;
}

.dashboard-map-slot :deep(.card-body) {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 7px 9px 9px !important;
}

.dashboard-map-slot
  :deep(.card-body > div:not(.spinner-container):not(.error-container)) {
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.dashboard-map-slot :deep(.map) {
  width: 100% !important;
  flex: 1 1 auto;
  min-height: 0;
  height: auto !important;
  border-radius: 11px;
}

.dashboard-map-slot :deep(.map-legend) {
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;
  justify-content: center;
  padding-top: 7px;
  margin-top: 0;
}

.dashboard-map-slot :deep(.legend-item) {
  font-size: 11.5px !important;
  line-height: 1.2;
}

/* Loading and empty states */
.dashboard-card-slot :deep(.spinner-container),
.dashboard-card-slot :deep(.loading-center),
.dashboard-card-slot :deep(.error-container) {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-card-slot :deep(.error-container) {
  flex-direction: column;
  text-align: center;
}

.dashboard-card-slot :deep(.error-image) {
  max-width: 115px !important;
}

.dashboard-card-slot :deep(.error-message) {
  font-size: 12px !important;
  font-weight: 600;
  color: #475569;
  margin: 0;
}

/* Floating Real Time Tracker button */
.floating-live-track-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1c66ad 0%, #253069 100%);
  color: white;
  border: none;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.22);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.25s ease;
  z-index: 1000;
}

.floating-live-track-btn:hover {
  transform: translateY(-2px) scale(1.04);
}

.floating-live-track-btn:active {
  transform: scale(0.96);
}

.loading-spinner {
  width: 26px;
  height: 26px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.floating-live-track-btn:disabled {
  opacity: 1;
  background: #253069;
  cursor: wait;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Medium screens */
@media (max-width: 1399px) {
  .dashboard-pair-row {
    gap: 8px;
    margin-bottom: 8px;
  }

  .dashboard-card-slot :deep(.target-filter-select),
  .dashboard-card-slot :deep(.target-user-select),
  .dashboard-card-slot :deep(.target-sku-select),
  .dashboard-card-slot :deep(.target-measure-select) {
    flex: 1 1 calc(33.333% - 6px);
    max-width: none;
  }

  .dashboard-card-slot :deep(.target-year-select) {
    flex: 0 0 84px;
    max-width: 90px;
  }

  .dashboard-card-slot :deep(.target-view-btn) {
    flex: 1 1 110px;
  }
}

/* Tablet */
@media (max-width: 991px) {
  .dashboard-shell {
    padding: 6px 7px 14px;
  }

  .dashboard-pair-row {
    grid-template-columns: 1fr;
    gap: 8px;
    margin-bottom: 8px;
  }

  .dashboard-card-slot :deep(.card) {
    height: auto;
  }

  .dashboard-map-slot :deep(.map) {
    height: 310px !important;
    min-height: 310px;
    flex: none;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .dashboard-shell {
    padding: 5px 6px 12px;
  }

  .dashboard-pair-row {
    gap: 7px;
    margin-bottom: 7px;
  }

  .dashboard-card-slot :deep(.card) {
    border-radius: 13px;
  }

  .dashboard-card-slot :deep(.card-header) {
    padding: 8px 9px 6px !important;
  }

  .dashboard-card-slot :deep(.card-body) {
    padding: 6px 7px 8px !important;
  }

  .dashboard-card-slot :deep(.card-header h5),
  .dashboard-card-slot :deep(h5) {
    font-size: 12.5px !important;
  }

  .dashboard-card-slot :deep(th),
  .dashboard-card-slot :deep(td) {
    font-size: 11px !important;
    padding: 6px 7px !important;
  }

  .dashboard-card-slot :deep(.target-filter-select),
  .dashboard-card-slot :deep(.target-user-select),
  .dashboard-card-slot :deep(.target-year-select),
  .dashboard-card-slot :deep(.target-sku-select),
  .dashboard-card-slot :deep(.target-measure-select),
  .dashboard-card-slot :deep(.target-view-btn) {
    flex: 1 1 calc(50% - 6px);
    max-width: none;
    width: 100%;
    min-width: 0;
    font-size: 11px !important;
  }

  .dashboard-card-slot :deep(select),
  .dashboard-card-slot :deep(.form-select),
  .dashboard-card-slot :deep(.btn) {
    width: 100%;
    min-width: 0;
    font-size: 11px !important;
  }

  .dashboard-card-slot :deep(.target-card .chart-container),
  .dashboard-card-slot :deep(.chart-container) {
    min-height: 240px;
    overflow-x: auto !important;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
  }

  .dashboard-card-slot :deep(.chart-container::-webkit-scrollbar) {
    height: 4px;
  }

  .dashboard-card-slot :deep(.chart-container::-webkit-scrollbar-track) {
    background: transparent;
  }

  .dashboard-card-slot :deep(.chart-container::-webkit-scrollbar-thumb) {
    background: #cbd5e1;
    border-radius: 999px;
  }

  .dashboard-card-slot :deep(.invoice-summary-grid) {
    grid-template-columns: 1fr;
  }

  .dashboard-map-slot :deep(.map) {
    height: 290px !important;
    min-height: 290px;
    flex: none;
  }

  .floating-live-track-btn {
    width: 44px;
    height: 44px;
    font-size: 16px;
    bottom: 15px;
    right: 15px;
  }
}

/* Small mobile */
@media (max-width: 480px) {
  .dashboard-shell {
    padding: 4px 5px 10px;
  }

  .dashboard-pair-row {
    gap: 6px;
    margin-bottom: 6px;
  }

  .dashboard-card-slot :deep(.target-filter-select),
  .dashboard-card-slot :deep(.target-user-select),
  .dashboard-card-slot :deep(.target-year-select),
  .dashboard-card-slot :deep(.target-sku-select),
  .dashboard-card-slot :deep(.target-measure-select),
  .dashboard-card-slot :deep(.target-view-btn) {
    flex: 1 1 100%;
  }

  .dashboard-card-slot :deep(.target-card .chart-container) {
    min-height: 225px;
  }

  .dashboard-map-slot :deep(.map) {
    height: 260px !important;
    min-height: 260px;
  }
}

.dashboard-card-slot :deep(.sku-sales-card *) {
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.42) transparent;
}

.dashboard-card-slot :deep(.sku-sales-card *::-webkit-scrollbar) {
  width: 3px;
  height: 3px;
}

.dashboard-card-slot :deep(.sku-sales-card *::-webkit-scrollbar-track) {
  background: transparent;
}

.dashboard-card-slot :deep(.sku-sales-card *::-webkit-scrollbar-thumb) {
  background: rgba(148, 163, 184, 0.42);
  border-radius: 999px;
}

.dashboard-card-slot :deep(.sku-sales-card *::-webkit-scrollbar-thumb:hover) {
  background: rgba(100, 116, 139, 0.65);
}
</style>
